import { defineMessages } from 'react-intl';

const messages = defineMessages({
  brandName: {
    id: 'navigation.brandName',
    defaultMessage: 'waltzing',
    description: 'Brand name in navigation',
  },
  additionalMenuItems: {
    id: 'navigation.additionalMenuItems',
    defaultMessage: 'More ...',
    description: 'Label for additional menu items button in navigation',
  },
  play: {
    id: 'navigation.play',
    defaultMessage: 'Play',
    description: 'Play link in navigation',
  },
  services: {
    id: 'navigation.services',
    defaultMessage: 'Services',
    description: 'Services link in navigation',
  },
  products: {
    id: 'navigation.products',
    defaultMessage: 'Products',
    description: 'Products link in navigation',
  },
  aboutUs: {
    id: 'navigation.aboutUs',
    defaultMessage: 'About Us',
    description: 'About Us link in navigation',
  },
  careers: {
    id: 'navigation.careers',
    defaultMessage: 'Careers',
    description: 'Careers link in navigation',
  },
  contactUs: {
    id: 'navigation.contactUs',
    defaultMessage: 'Contact Us',
    description: 'Contact Us link in navigation',
  },
  imprint: {
    id: 'navigation.imprint',
    defaultMessage: 'Imprint',
    description: 'Imprint link in navigation',
  },
  learning: {
    id: 'navigation.learning',
    defaultMessage: 'Learning',
    description: 'Learning link in navigation',
  },
  help: {
    id: 'navigation.help',
    defaultMessage: 'Help & Tutorials',
    description: 'Help & Tutorials link in navigation',
  },
  forum: {
    id: 'navigation.forum',
    defaultMessage: 'Forum',
    description: 'Forum link in navigation',
  },
});

export default messages;



// WEBPACK FOOTER //
// ./src/components/Navigation/messages.js